import allSettled from 'promise.allsettled'

export const handleUploadErrorResponse = (response) => {
    const defaultError = 'Image upload failed.'
    try {
        response.json().then((body) => {
            if (body.message) {
                throw Error(body.message)
            }

            throw Error(defaultError)
        })
    } catch (error) {
        throw Error(defaultError)
    }
}

const createACardAddToCart = async (
    imageUploadUrl,
    cards,
    setAddingToCart,
    resetForm,
    resetCardList,
    sendAddToCartRequest,
    addToCartCallback,
    handleCartError
) => {
    setAddingToCart(true)
    console.log('addToCart cards', cards)

    const items = await cards.map(async (card) => {
        return {
            amount: card.amount,
            card_network: card.cardNetwork.name,
            quantity: card.quantity,
            name_on_card: card.nameOnCard,
            message_on_card: card.messageOnCard,
            carrier_from: card.carrierFrom,
            carrier_message: card.carrierMessage,
            shipping_name: card.recipientName,
            address_line1: card.addressLine1,
            address_line2: card.addressLine2,
            city: card.city,
            state: card.state,
            zip: card.zip,
            shipping_method: card.shippingMethod,
            cloudinary_id: card.cloudinaryId,
        }
    })

    allSettled.shim() // will be a no-op if not needed

    const uploadedItems = await Promise.allSettled(items)
    const validItems = uploadedItems
        .filter((item) => item.status === 'fulfilled')
        .map((item) => {
            return item.value
        })
    if (!validItems.length) {
        setAddingToCart(false)
        handleCartError(
            'Add to cart failed. Please try again or select a new card image.'
        )
    } else {
        try {
            const addResponse = await sendAddToCartRequest(
                JSON.stringify({ cards: validItems })
            )
            resetForm()
            resetCardList()
            addToCartCallback(addResponse)
        } catch (error) {
            setAddingToCart(false)
            handleCartError(error)
        }
    }
}

export default createACardAddToCart
